import api from "../../utils/axios-util";
import Middleware from "../../utils/api-middleware"



// export const AsterCalllog = (payload) => {
//   return (dispatch, getState) => {
//     return new Promise(async (resolve, reject) => {
//       await api.post(`/calllog`, payload).then(response => {
//         resolve(response);
//       }).catch((err) => {
//         reject(err)
//       })
//     })
//   }

// };

// export const AsterInbound = (payload) => {
//   return (dispatch, getState) => {
//     return new Promise(async (resolve, reject) => {
//       await api.post(`/calllog`, payload).then(response => {
//         resolve(response);
//       }).catch((err) => {
//         reject(err)
//       })
//     })
//   }

// };

// export const AsterOutbound = (payload) => {
//   return (dispatch, getState) => {
//     return new Promise(async (resolve, reject) => {
//       await api.post(`/calllog`, payload).then(response => {
//         resolve(response);
//       }).catch((err) => {
//         reject(err)
//       })
//     })
//   }

// };


export const AsterAbandoned = (payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api.post(`/calllog`, payload).then(response => {
        let res = Middleware("select CRM", "fetch", response)
        resolve(res);
      })
        .catch((err) => {
          console.log(err,"AsterAbandoned erorr");
          
          let res = Middleware("select CRM", "fetch", err.response.data, "catch")
          reject(res);
        });
    })
  }

};

// export const AsterCalllogSearch = (payload) => {
//   return (dispatch, getState) => {
//     return new Promise(async (resolve, reject) => {
//       await api.post(`/calllog`, payload).then(response => {
//         resolve(response);
//       }).catch((err) => {
//         reject(err)
//       })
//     })
//   }

// };

// export const AsterInboundSearch = (payload) => {
//   return (dispatch, getState) => {
//     return new Promise(async (resolve, reject) => {
//       await api.post(`/calllog`, payload).then(response => {
//         resolve(response);
//       }).catch((err) => {
//         reject(err)
//       })
//     })
//   }

// };


// export const AsterOutboundSearch = (payload) => {
//   return (dispatch, getState) => {
//     return new Promise(async (resolve, reject) => {
//       await api.post(`/calllog`, payload).then(response => {
//         resolve(response);
//       }).catch((err) => {
//         reject(err)
//       })
//     })
//   }

// };

export const AsterAbandonedSearch = (payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api.post(`/calllog`, payload).then(response => {
        let res = Middleware("select CRM", "fetch", response)
        resolve(res);
      })
        .catch((err) => {
          let res = Middleware("select CRM", "fetch", err.response.data, "catch")
          reject(res);
        });
    })
  }

};

export const AsterGetCampaigns = (payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api.get(`/campaigntype?campaign_name=${payload}`).then(response => {
        let res = Middleware("select CRM", "fetch", response)
        if(res.statusCode===200){
        localStorage.setItem("selectedCampaign_data", JSON.stringify(res.data[0]))
        }
        resolve(res);
      })
        .catch((err) => {
          let res = Middleware("select CRM", "fetch", err.response.data, "catch")
          reject(res);
        });
    })
  }

};

export const AsterUpdateAgent = (payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api.put(`/asterdialer/agent/live/${payload.user}`, { campaign: payload.campaign, dialer_flag: payload.dialer_flag }).then(response => {
        let res = Middleware("select CRM", "update", response)
        resolve(res);
      })
        .catch((err) => {
          let res = Middleware("select CRM", "update", err.response.data, "catch")
          reject(res);
        });
    })
  }

};

export const AsterOtherAgent = (payload) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      await api.post(`/otherAgentStatus`, payload).then(response => {
        let res = Middleware("select CRM", "fetch", response)
        if (res.statusCode == 200) {
          dispatch({
            type: 'AGENTSTATUS',
            payload: res.data
          })
        }
        resolve(res);
      }).catch((err) => {
        let res = Middleware("select CRM", "fetch", err.response.data, "catch")
        reject(res);      })
    })
  }

};

